import React, { useState } from 'react';
import './Filter.css';

const categorias = [
  'TODOS',
  'SOM',
  'MICROFONES',
  'MESAS DE SOM',
  'DJ',
  'ILUMINAÇÃO',
  'VÍDEO',
  'SUPORTES',
  'ACESSÓRIOS AUDIO',
  'PRODUÇÃO CONTEÚDO',
  'TABLETS'
];

export default function Filter({ onFilter }) {
  const [ativo, setAtivo] = useState('TODOS');

  const handleClick = (categoria) => {
    setAtivo(categoria);
    onFilter(categoria);
  };

  return (
    <div className="filter-container">
      {categorias.map((cat) => (
        <button
          key={cat}
          className={`filter-btn ${ativo === cat ? 'ativo' : ''}`}
          onClick={() => handleClick(cat)}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}